// SignedOutView.tsx
import { useEffect, useRef } from 'react';

interface SignedOutViewProps {
    googleInitialized: boolean;
}

export default function SignedOutView({ googleInitialized }: SignedOutViewProps) {
    const buttonRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (buttonRef.current && googleInitialized && window.google?.accounts) {
            window.google.accounts.id.renderButton(
                buttonRef.current,
                { theme: 'outline', size: 'large' }
            );
        }
    }, [googleInitialized]);

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'flex-start',
                paddingTop: '25vh',
                minHeight: '100vh',
                textAlign: 'center',
            }}
        >
            <h1>Crappy UI for Awesome AI</h1>
            <p>Login with Google to get started</p>
            <div ref={buttonRef} id="gsi-btn" className="mx-auto" style={{ width: '240px' }} />
        </div>
    );
}